<script setup lang="ts">
import { StoreName } from '~~/interfaces/network'
import {
    getAppStoreChargemapUrl,
    getPlayStoreChargemapUrl
} from '~~/app/utils/url'

export interface Props {
    storeName?: StoreName | ''
}

const props = withDefaults(defineProps<Props>(), {
    storeName: ''
})

const config = useRuntimeConfig()

const imagePath = computed<string>(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return `${config.app.cdnURL}/images/cmp-store/${useLanguage()}/app-store-badge.svg`
        case StoreName.GooglePlay:
            return `${config.app.cdnURL}/images/cmp-store/${useLanguage()}/google-play-badge.png`
        default:
            return ''
    }
})

const imageUrl = computed<string>(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return getAppStoreChargemapUrl()
        case StoreName.GooglePlay:
            return getPlayStoreChargemapUrl()
        default:
            return ''
    }
})

const gtmClass = computed<string>(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return 'gtm-AppStore'
        case StoreName.GooglePlay:
            return 'gtm-GooglePlay'
        default:
            return ''
    }
})

const rating = computed<number>(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return 4.7
        case StoreName.GooglePlay:
            return 4.6
        default:
            return 0
    }
})
</script>

<template>
    <div class="flex flex-col justify-center items-center gap-1">
        <NuxtLink
            target="_blank"
            :class="gtmClass"
            :to="imageUrl"
            :title="$t('home.download.' + storeName)"
        >
            <NuxtImg :src="imagePath" :alt="$t('home.download.' + storeName)" />
        </NuxtLink>
        <div class="flex justify-center items-center gap-1">
            <div class="flex justify-center items-center text-[#F59F0A]">
                <IconStarFull class="size-5" />
                <IconStarFull class="size-5" />
                <IconStarFull class="size-5" />
                <IconStarFull class="size-5" />
                <IconStarHalf class="size-5" />
            </div>
            <span
                v-if="rating"
                class="text-sky-600 text-base font-medium font-inter leading-tight"
            >
                {{ rating }}
            </span>
        </div>
    </div>
</template>
